import { register } from './mount';

const components = {
    // "css selector": "path/to/component.js",
    'astrology-compatibility': 'compatibility/astrology',
    'birthday-select': 'responsive/birthday-select',
    'catalog-content': 'catalog/content',
    'catalog-inputs': 'catalog/inputs',
    'compatibility-chooser': 'compatibility/chooser',
    'cosmic-profile': 'cosmic-profile',
    'daily-hexagram': 'daily/hexagram/index',
    'daily-horoscope': 'daily/horoscope',
    'daily-number': 'daily/number/index',
    'daily-tarot-card': 'daily/tarot-card/index',
    'date-picker': 'date-picker',
    'date-select': 'fields/date',
    'desktop-nav-dropdown': 'responsive/desktop-nav-dropdown',
    'discount-message': 'karmacoin-store/discount-message',
    'email-unsub': 'member/email-unsub',
    'eyeota': 'eyeota',
    'feedback-tab': 'feedback/tab',
    'feedback-form': 'feedback/form',
    'ga-events': 'ga-events',
    'gdpr-cmp-sortable': 'gdpr-cmp-sortable',
    'hexagram-content': 'content/hexagram',
    'input-validation': 'form/input-validation',
    'i-ching-reading': 'i-ching-reading',
    'karmacoin-header': 'karmacoin-store/karmacoin-header',
    'karmacoin-submit': 'karmacoin-store/karmacoin-submit',
    'light-box': 'light-box',
    'logged-in': 'logged-in',
    'logged-out': 'logged-out',
    'login-modal': 'user/login-modal',
    'member-email-preferences': 'member/email-preferences',
    'mini-horoscope': 'mini-horoscope',
    'mini-tcod': 'mini-tcod',
    'mobile-daily-links': 'mobile-daily-links',
    'mobile-nav-dropdown': 'mobile-nav-dropdown',
    'moon-phase': 'moon-phase',
    'more-scopes-menu': 'more-scopes-menu',
    'more-today': 'more-today',
    'nav-bar': 'nav-bar',
    'nav-bar-mobile' : 'nav-bar-mobile',
    'oranum-psychics': 'oranum-psychics',
    'oranum-psychics-responsive': 'responsive/oranum-psychics',
    'planet-tracker': 'planet-tracker',
    'policy-consent': 'policy-consent',
    'power-package': 'karmacoin-store/power-package',
    'product-message': 'product-message',
    'promo-message': 'promo-message',
    'promoted-content': 'content/promoted',
    'report-teeup': 'report-teeup',
    'sale-message': 'sale-message',
    'signup-forums': 'user/signup-forums',
    'signup-modal': 'user/signup-modal',
    'signup-modal-desktop': 'user/signup-modal-desktop',
    'a[data-is=smooth-scroll]': 'smooth-scroll',
    'div[data-is=page-accordion]': 'page-accordion',
    'raw': 'raw',
    'responsive-login-modal': 'responsive/login-modal',
    'responsive-planet-tracker': 'responsive/planet-tracker',
    'responsive-promoted-content': 'responsive/promoted-content',
    'responsive-signup-modal': 'responsive/signup-modal',
    'show-details': 'show-details',
    'standard-package': 'karmacoin-store/standard-package',
    'standard-packages': 'karmacoin-store/standard-packages',
    'subscription-teeup': 'subscription-teeup',
    'tarot-card-browser': 'tarot-card-browser',
    'tarot-reading': 'tarot-readings/tarot-reading',
    'tarot-top-bar': 'tarot-top-bar',
    'today-module-nav': 'today-module-nav',
    'top-bar': 'responsive/top-bar',
    'user-menu': 'user/menu',
    'weekly-love-horoscope': 'weekly/love-horoscope',
    'zodiac-sign-picker': 'zodiac-sign-picker',
};

Object.keys(components).forEach((tag) => {
    const path = components[tag];
    const { default: Component } = require(`../components/${path}`);
    register(tag, Component);
});



// WEBPACK FOOTER //
// ./app/preact/index.js